import {
  DELETE_SUB_CATEGORY,
  DELETE_SUB_CATEGORY_FAILURE,
  DELETE_SUB_CATEGORY_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const deleteSubCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_SUB_CATEGORY:
      return { ...state, loading: true };
    case DELETE_SUB_CATEGORY_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case DELETE_SUB_CATEGORY_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default deleteSubCategoryReducer;
